export enum ActionType {
  WALLET_CONNECTION = "WALLET_CONNECTION",
  DISCONNECT_WALLET = "DISCONNECT_WALLET",
};

interface WalletConnectionAction {
  type: ActionType.WALLET_CONNECTION,
  payload: {
    isConnected: boolean,
    publicKey: string,
    chainID: string,
    walletType: string
  }
}

interface DisconnectWalletAction {
  type: ActionType.DISCONNECT_WALLET,
  payload: {
    isConnected: boolean,
    publicKey: string,
    chainID: string
  }
}

export type Action = WalletConnectionAction | DisconnectWalletAction;
